import React from "react";
import Button from '../UI/Button';

const NFCScanner = ({ onScan }) => {
    const scanNFC = async () => {
        if (!("NDEFReader" in window)) {
            alert("Web NFC не поддерживается этим браузером.");
            return;
        }

        try {
            const ndef = new window.NDEFReader();
            await ndef.scan();

            ndef.onreading = (event) => {
                const decoder = new TextDecoder();
                const tagId = decoder.decode(event.message.records[0].data);
                if (onScan) onScan(tagId);
            };
        } catch (err) {
            console.error("Ошибка сканирования NFC:", err);
            alert("Ошибка при чтении метки.");
        }
    };

    const emulateScan = () => {
        const testTagId = prompt("🧪 Введите тестовый tagId:");
        if (testTagId && onScan) onScan(testTagId);
    };

    return (
        <div className="flex gap-2 mb-4">
            <Button
                onClick={scanNFC}
                variant="primary"
            >
                📡 Сканировать NFC
            </Button>
            <Button
                onClick={emulateScan}
                variant="secondary"
            >
                🧪 Эмуляция
            </Button>
        </div>
    );
};

export default NFCScanner;
